import Papa from 'papaparse';

const CSVHelper = {
  parse(file: File): Promise<Papa.ParseResult> {
    return new Promise((complete: (result: Papa.ParseResult) => void) => {
      Papa.parse(file, {
        header: true,
        delimiter: ',',
        skipEmptyLines: 'greedy',
        complete,
      });
    });
  },
};

export default CSVHelper;
